var map = {
	"./amazon.png": 6049,
	"./asana.png": 5485,
	"./atlassian.png": 457,
	"./citadel.png": 7513,
	"./databricks.png": 8584,
	"./datadog.png": 4868,
	"./google.png": 491,
	"./hp.png": 3580,
	"./imc.png": 8881,
	"./meta.png": 652,
	"./microsoft.png": 2322,
	"./nasa2Jpl.png": 7390,
	"./nasaJpl.png": 9838,
	"./optiver.png": 9939,
	"./paypal.png": 9413,
	"./rivian.png": 9540,
	"./scale.png": 9162,
	"./squarespace.png": 4803,
	"./statefarm.png": 7419,
	"./uber.png": 3982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4959;